import { render } from "./RecordButtons.vue?vue&type=template&id=1339d224"
import script from "./RecordButtons.vue?vue&type=script&lang=js"
export * from "./RecordButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__